import { CostCenterSummary, Identity } from '@libs/core/api';

export interface ProjectBillingDetails {
  legalName?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  vatNumber?: string;
  recipientCode?: string;
  projectCode?: string;
  projectName?: string;
}

function trimToOptional(value?: string | null): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function buildProjectBillingDetails(
  project: CostCenterSummary,
  user: Identity | null
): ProjectBillingDetails {
  if (!user?.companies?.length || project?.id == null) {
    return {};
  }

  const company = user.companies.find((c) =>
    c.costCenters?.some((p) => p.id === project.id)
  );

  if (!company) {
    return {};
  }

  return {
    legalName: trimToOptional(company.legalName ?? company.name),
    address: trimToOptional(company.address),
    zipCode: trimToOptional(company.zipCode),
    city: trimToOptional(company.city),
    vatNumber: trimToOptional(company.vatNumber),
    recipientCode: trimToOptional(company.recipientCode),
    projectCode: trimToOptional(project.businessCentralNumber),
    projectName: trimToOptional(project.description),
  };
}
